module.exports = __webpack_public_path__ + "static/media/BigPlus.a114faf8.svg";